<script setup>
import { Head, Link } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import AppLayout from '../../Layouts/AppLayout.vue'

const { t } = useI18n()
</script>

<template>
  <Head :title="t('messages.invitations.error.email_taken_title')" />

  <AppLayout>
    <div class="flex justify-center mt-12">
      <Card class="max-w-md w-full">
        <template #content>
          <div class="flex flex-col items-center gap-4 text-center">
            <i class="pi pi-info-circle text-5xl text-blue-500"></i>
            <h1 class="text-xl font-medium m-0">
              {{ t('messages.invitations.error.email_taken_title') }}
            </h1>
            <p class="text-sm text-gray-600 m-0">
              {{ t('messages.invitations.error.email_taken_description') }}
            </p>
            <Link :href="route('login')">
              <Button>
                {{ t('messages.invitations.accept.go_to_login') }}
              </Button>
            </Link>
          </div>
        </template>
      </Card>
    </div>
  </AppLayout>
</template>
